<template>
  <v-container fluid>
    <v-row>
        <v-col cols="12">
            <v-card :loading="loading" :disabled="loading">
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title>Notifications config</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col>Event</v-col>
                        <v-col>Channel</v-col>
                        <v-col>Shop</v-col>
                    </v-row>
                    <notification-subscription v-for="line in config" :key="line.type" :notification="line" />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NotificationSubscription from '../../components/notifications/NotificationSubscription.vue'
export default {
    components: {
        NotificationSubscription
    },
    computed: {
        ...mapGetters('notifications', ['loading', 'config'])
    },
    mounted() {
        this.fetchConfig()
    },
    methods: {
        ...mapActions('notifications', {
            fetchConfig: 'fetchConfig'
        })
    }

}
</script>

<style>

</style>